// extracted by mini-css-extract-plugin
export default {"container":"TradeMemoPage_container__+9X+v","title":"TradeMemoPage_title__NJKyj","tradeItem":"TradeMemoPage_tradeItem__D33BR","tradeTitle":"TradeMemoPage_tradeTitle__fBCWc"};